import actionType from 'redux/actions/actionConstant';

const initialState = {
    open: false,
    message: '',
    variant: '',
    duration: 5000,
};

export default function toaster(state = initialState, action) {
    switch (action.type) {
        case actionType.OPEN_TOASTER:
            return {
                ...state,
                open: true,
                message: action.payload.message,
                variant: action.payload.variant,
                duration: action.payload.duration === undefined ? 5000 : action.payload.duration,
            };
        case actionType.CLOSE_TOASTER:
            return {
                ...state,
                open: false,
            };
        case actionType.CLEAR_TOASTER:
            return {
                ...state,
                message: '',
                variant: '',
            };
        default:
            return state;
    }
}
